/* Le Chic Beauty: copy corrections applied on top of the catalog and store FAQs (2026-10-20).
   Keeps product pages in line with the store policies and avoids unsupported claims. */
(function () {
  var LC = window.LC;
  if (!LC) return;
  // Active again (2026-10-20): lc-bridge.js adds them from live Shopify data, so their colors
  // and variants match the store. Helix stays listed here: lc-helix-restore.js restores it.
  if (Array.isArray(LC.retiredIds)) {
    LC.retiredIds = LC.retiredIds.filter(function (id) {
      return ['thermal-fusion-infrared-blow-dryer', 'zephyr-salon-turbo-blow-dryer', 'super-curl-automatic-curler'].indexOf(id) === -1;
    });
  }
  var fix = function (s) {
    if (typeof s !== 'string') return s;
    return s
      .replace(/No damage installation/g, 'Gentle, glue-free installation')
      .replace(/damage-free application/g, 'gentle application')
      .replace(/to help prevent tangling and breakage/g, 'to help reduce tangling')
      .replace(/ from the inside out/g, '')
      .replace(/Infrared heat penetrates hair more efficiently than traditional surface heat/g, 'Infrared heat distributes warmth more evenly than traditional surface heat')
      .replace(/Infrared heat gently penetrates the hair shaft/g, 'Infrared heat warms hair gently and evenly');
  };
  (LC.products || []).forEach(function (p) {
    ['highlights', 'benefits'].forEach(function (k) {
      (p[k] || []).forEach(function (h) { h.title = fix(h.title); h.text = fix(h.text); });
    });
    p.features = (p.features || []).map(fix);
    p.description = fix(p.description);
    // "CurvEase" is not a Le Chic Beauty trademark: the brush keeps its plain name
    p.name = String(p.name).replace(/CurvEase,? /g, '');
    p.description = String(p.description).replace(/CurvEase,? /g, '');
    (p.images || []).forEach(function (i) { if (i.alt) i.alt = String(i.alt).replace(/CurvEase,? /g, ''); });
    if (p.id === 'repairing-caviar-shampoo') {
      (p.highlights || []).forEach(function (h) {
        if (/^Sulfate/i.test(h.title)) { h.title = 'Paraben-Free Formula'; h.text = 'A gentle cleansing formula made without parabens.'; }
      });
      p.features = p.features.filter(function (f) { return !/sulfate-free/i.test(f); });
      p.description = String(p.description).replace(/([Ff])ree of sulfates and parabens/g, '$1ree of parabens');
    }
    // Sulfate-free isn't confirmed for the caviar line: no sulfate claims on any hair care product
    if (['hair-care', 'treatments'].indexOf(p.category) !== -1) {
      (p.highlights || []).forEach(function (h) {
        if (/sulfate/i.test(h.title)) { h.title = 'Gentle Formula'; h.text = 'A gentle, nourishing formula.'; }
      });
      p.features = (p.features || []).filter(function (f) { return !/sulfate/i.test(f); });
    }
  });
  // Journal articles (theme copy of the blog): same claim fixes as the Shopify posts
  var journalFixes = [
    ['so gentle that they can be worn every day without causing any damage to your natural hair', 'gentle enough to wear every day, with no glue, tape or heat touching your natural hair'],
    ['without causing any damage to your natural', 'with no glue, tape or heat touching your natural'],
    ['With good maintenance your Halo extensions can last up to 24 months.', 'With regular care, Le Chic Beauty Halo extensions should last nine months or longer, depending on how often they’re worn.'],
    ["there's no damage to your natural hair", "it's gentle on your natural hair"],
    ['Damage-Free: Say goodbye to hair breakage and stress! Halo extensions utilize gentle attachment methods that won\'t harm your natural hair.', 'Gentle on Your Hair: no glue, tape or heat touching your own hair. Halo extensions use a gentle attachment method that is easy on your natural hair.'],
    ['effortless, damage-free hairstyles', 'effortless, commitment-free hairstyles'],
    ['Are Halo Hair Extensions Damage-Free?', 'Are Halo Hair Extensions Gentle on Your Hair?']
  ];
  (window.LC_JOURNAL || []).forEach(function (a) {
    journalFixes.forEach(function (f) {
      ['body', 'excerpt'].forEach(function (k) {
        if (typeof a[k] === 'string') a[k] = a[k].split(f[0]).join(f[1]);
      });
    });
  });
  if (LC.collectionSeo) {
    if (LC.collectionSeo.care) LC.collectionSeo.care.intro = LC.collectionSeo.care.intro.replace('a sulfate-free shampoo', 'a shampoo');
    if (LC.collectionSeo['hair-care']) LC.collectionSeo['hair-care'].meta = LC.collectionSeo['hair-care'].meta.replace('sulfate- and paraben-free shampoo', 'paraben-free shampoo');
    // Halo extensions come in 26–27 shades per length
    if (LC.collectionSeo.extensions) {
      ['meta', 'intro'].forEach(function (k) {
        if (typeof LC.collectionSeo.extensions[k] === 'string') LC.collectionSeo.extensions[k] = LC.collectionSeo.extensions[k].replace(/in 28 shades/g, 'in over 25 shades');
      });
    }
  }
  if (LC.featureCopy && LC.featureCopy['repairing-caviar-shampoo']) {
    LC.featureCopy['repairing-caviar-shampoo'].line = 'A gentle cleanse with caviar and keratin.';
  }
  if (typeof LC.storeFaqs === 'function') {
    var storeFaqs = LC.storeFaqs;
    LC.storeFaqs = function (p) {
      var r = storeFaqs(p);
      var n = p ? LC.the(p) : 'your order';
      var N = n.charAt(0).toUpperCase() + n.slice(1);
      r.warranty[1] = 'Yes. ' + N + ' is covered by the Le Chic Beauty Limited Lifetime Warranty wherever you bought it. Register it within 14 days of purchase and keep your proof of purchase for any claim';
      r.shipping[1] = 'Orders placed before 3:00 PM Eastern on a business day ship the same day, with tracking; later orders ship the next business day. You will receive a tracking link by email once your order ships';
      r.returns[1] = 'Unused, unopened items bought directly from Le Chic Beauty can be returned within 30 days of delivery, with no restocking fee. Return shipping is paid by the customer. Hair care products are final sale. Purchases from other retailers follow that retailer’s policy';
      r.remy[1] = fix(r.remy[1]);
      r.haloDamage[1] = 'Le Chic Beauty halo extensions attach without glue, tape, heat or clips on your own hair: a fitted wire sits beneath your hair, so application is gentle. As with any extension, brush gently and remove them before sleeping';
      return r;
    };
  }
  if (typeof LC.faqsFor === 'function') {
    var faqsFor = LC.faqsFor;
    LC.faqsFor = function (p) {
      return faqsFor(p).map(function (f) {
        if (/have adjustable temperature\?$/i.test(f.q) && !/adjust|settings|\d+\s*°?\s*[FC]?\s*(to|–|-)\s*\d+/i.test(f.a)) {
          return { q: f.q.replace(/^Does (.*) have adjustable temperature\?$/i, 'What temperature does $1 reach?'), a: f.a.replace(/^Yes\.\s*/, '').replace(' features ', ' has a ') };
        }
        if (/sulfate-free and paraben-free\?$/i.test(f.q)) {
          return { q: f.q.replace(/sulfate-free and paraben-free\?$/i, 'paraben-free?'), a: 'Yes. A gentle cleansing formula made without parabens.' };
        }
        return f;
      });
    };
  }
  // Product page: Shipping & Returns tab matches the store policies; Subscribe & Save only
  // shows when Shopify has a real subscription plan for the product.
  var fixPdp = function () {
    var main = document.getElementById('product-main');
    if (!main || !LC.findProduct) return;
    var p = LC.findProduct(LC.param ? LC.param('id') : '');
    if (!p) return;
    var tool = ['flat-irons', 'blow-dryers', 'curling', 'travel'].indexOf(p.category) !== -1
      || (p.category === 'grooming' && /brush|straightener/i.test(p.name));
    main.querySelectorAll('.acc2 details').forEach(function (d) {
      var s = d.querySelector('summary');
      var body = d.querySelector('.acc-body');
      if (!s || !body || body.getAttribute('data-lc-fixed') || !/Shipping & Returns/.test(s.textContent)) return;
      body.setAttribute('data-lc-fixed', '1');
      body.innerHTML = '<p>Orders placed before 3:00 PM Eastern on a business day ship the same day, with tracking; later orders ship the next business day. An order can be cancelled or have its address changed only before it ships.</p>'
        + '<p>Unused, unopened items bought directly from Le Chic Beauty can be returned within 30 days of delivery, with no restocking fee. Return shipping is paid by the customer. Hair care products are final sale.'
        + (tool ? ' Hair tools are covered by the Le Chic Beauty Limited Lifetime Warranty wherever you bought them; register within 14 days of purchase.' : '')
        + '</p><p><a href="/policies/shipping-policy">Shipping policy</a> · <a href="/policies/refund-policy">Return policy</a>'
        + (tool ? ' · <a href="/pages/warranty-policy">Warranty policy</a>' : '') + '</p>';
    });
    // Buy-box promise line: same-day shipping (store policy), returns only where they apply
    var ship = main.querySelector('.pinfo .ship');
    if (ship && !ship.getAttribute('data-lc-fixed')) {
      ship.setAttribute('data-lc-fixed', '1');
      var care = ['hair-care', 'treatments'].indexOf(p.category) !== -1;
      ship.textContent = (tool ? 'Limited Lifetime Warranty · ' : '') + 'Same-day shipping on orders by 3 PM ET' + (care ? '' : ' · 30-day returns');
    }
    // Cross-sell: "Pairs Well With" picks by product type, in stock and buyable only
    var relTitle = main.querySelector('#related-title');
    var relGrid = relTitle && relTitle.closest('section') && relTitle.closest('section').querySelector('.product-grid');
    if (relGrid && !relGrid.getAttribute('data-lc-fixed') && typeof LC.cardHTML === 'function') {
      relGrid.setAttribute('data-lc-fixed', '1');
      var PAIRS = {
        'flat-irons': ['heat-mat', 'chase-comb-1', 'repairing-caviar-hair-serum', 'glaciere-hot-tool-holder'],
        'blow-dryers': ['vented-and-curved-detangle-brush', 'repairing-caviar-hair-serum', 'heat-mat', 'repairing-caviar-hair-mask'],
        'curling': ['heat-mat', 'glaciere-hot-tool-holder', 'repairing-caviar-hair-serum', 'repairing-caviar-hair-mask'],
        'travel': ['heat-mat', 'repairing-caviar-hair-serum', 'vented-and-curved-detangle-brush', 'chase-comb-1'],
        'hair-care': ['repairing-caviar-shampoo', 'repairing-caviar-conditioner', 'repairing-caviar-hair-mask', 'repairing-caviar-hair-serum', 'vented-and-curved-detangle-brush'],
        'extensions': ['vented-and-curved-detangle-brush', 'repairing-caviar-shampoo', 'repairing-caviar-conditioner', 'repairing-caviar-hair-mask'],
        'accessories': ['ionik-ceramic-flat-iron', 'repairing-caviar-hair-serum', 'heat-mat', 'vented-and-curved-detangle-brush'],
        'grooming': ['heat-mat', 'glaciere-hot-tool-holder']
      };
      var picks = (PAIRS[p.category] || []).map(LC.findProduct).filter(function (x) {
        return x && x.id !== p.id && x.price != null && x.available !== false && x.inShop !== false && !(LC.isSoldOut && LC.isSoldOut(x));
      }).slice(0, 4);
      if (picks.length >= 2) {
        relTitle.textContent = 'Pairs Well With';
        var chip = relTitle.parentNode.querySelector('.chip');
        if (chip) chip.textContent = 'Complete Your Routine';
        relGrid.innerHTML = picks.map(function (x) { return LC.cardHTML(x); }).join('');
      }
    }
    if (!p.hasPlans) {
      var wrap = main.querySelector('.purchase-wrap');
      if (wrap) wrap.remove();
    }
  };
  var watchPdp = function () {
    fixPdp();
    var main = document.getElementById('product-main');
    if (main && 'MutationObserver' in window) new MutationObserver(fixPdp).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPdp);
  else watchPdp();

  // Store-wide copy in the help center, collection and guide pages (rendered by their own
  // scripts): same policy wording as the Shopify policies, in the page text and its JSON-LD.
  var textFixes = [
    [/ purchased from Le Chic Beauty or an authorized retailer (are|is) covered by/g, ' $1 covered, wherever you bought them, by'],
    [/(bought|purchased) from Le Chic Beauty or an authorized retailer/g, 'bought anywhere, Amazon and eBay included'],
    [/The warranty doesn’t apply to tools bought from unauthorized sellers\./g, 'Keep your proof of purchase for any claim.'],
    [/Tools bought from unauthorized sellers, including Amazon, eBay and other resale platforms, aren’t eligible\./g, 'Tools are covered wherever you bought them, Amazon and eBay included.'],
    [/If your order has already shipped, you may request a return\/refund within 30 days of delivery/g, 'Unused, unopened items can be returned within 30 days of delivery'],
    [/A 10% restocking fee applies to unused, unopened items and a 30% restocking fee applies to used or opened items\./g, 'There is no restocking fee. Hair care products are final sale.'],
    [/a 10% restocking fee applies to unused, unopened items and a 30% fee to used or opened items/g, 'there is no restocking fee'],
    [/No\. Le Chic Beauty halo extensions fit without weaving/g, 'They’re designed to be gentle. Le Chic Beauty halo extensions fit without weaving'],
    [/fastest, damage-free application/g, 'fastest, gentlest application'],
    [/damage-free application/g, 'gentle application'],
    [/come in 28 shades/g, 'come in over 25 shades'],
    [/Orders typically ship within 1–2 business days\./g, 'Orders placed by 3 PM ET on a business day ship the same day.'],
    [/^Ships in 1–2 business days$/g, 'Same-day shipping'],
    [/^Every order is tracked$/g, 'On orders by 3 PM ET, tracked'],
    [/ Ships in 1–2 business days\./g, ' Same-day shipping by 3 PM ET.']
  ];
  var fixText = function (t) {
    var out = t;
    textFixes.forEach(function (f) { out = out.replace(f[0], f[1]); });
    return out;
  };
  var fixPageText = function () {
    if (!document.body) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v && v.length > 20) { var f = fixText(v); if (f !== v) node.nodeValue = f; }
    }
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
      var v = s.textContent; var f = fixText(v); if (f !== v) s.textContent = f;
    });
    var meta = document.querySelector('meta[name="description"]');
    if (meta) { var c = meta.getAttribute('content') || ''; var fc = fixText(c); if (fc !== c) meta.setAttribute('content', fc); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixPageText);
  else fixPageText();
  window.addEventListener('load', fixPageText);
})();
